export default __webpack_public_path__ + "static/media/lv6.bbb72123.png";